import _ from 'lodash'

export const convertPluralQuantityToSingular = (
  quantityType: string
): string => {
  if (quantityType === 'capsules' || quantityType === 'lozenges') {
    return _.trimEnd(quantityType, 's')
  } 
    return _.trimEnd(quantityType, 'es')
  
}

export const convertDoseNumberToWord = (
  dose: number,
  quantityType: string
): string | number => {
  // If the quantity is in ml, we want it to always be a number.
  if (quantityType === 'ml') return dose

  switch (dose) {
    case 1:
      return 'ONE'
    case 2:
      return 'TWO'
    case 3:
      return 'THREE'
    case 4:
      return 'FOUR'
    case 5:
      return 'FIVE'
    default:
      return dose
  }
}
